module.exports = __webpack_public_path__ + "img/icon_04.dd62b1e1.svg";